(() => {
  const configNode = document.getElementById('mm-wishlist-config');
  const dialog = document.getElementById('mm-wishlist');
  if (!configNode || !dialog || !dialog.showModal) return;
  const config = JSON.parse(configNode.textContent);
  const t = config.strings;
  const key = 'mm-wishlist-v1';
  const root = config.root.replace(/\/?$/, '/');
  const grid = dialog.querySelector('[data-mm-wish-grid]');
  const empty = dialog.querySelector('[data-mm-wish-empty]');
  const status = document.querySelector('[data-mm-wish-status]');
  const valid = item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle);
  const parse = value => {
    try {
      const data = JSON.parse(value || '[]');
      return Array.isArray(data) ? data.filter(valid).filter((item, i, all) => all.findIndex(other => other.handle === item.handle) === i).slice(0, 100) : [];
    } catch { return []; }
  };
  let items = [];
  let persistent = true;
  try { items = parse(localStorage.getItem(key)); } catch { persistent = false; }
  let openedBy;
  let generation = 0;
  let timer;
  const money = value => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(value / 100);
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const safeImage = value => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com') ? url.href : '';
    } catch { return ''; }
  };
  const announce = text => {
    clearTimeout(timer);
    status.textContent = text;
    dialog.querySelector('[data-mm-wish-dialog-status]').textContent = dialog.open ? text : '';
    status.classList.add('is-visible');
    timer = setTimeout(() => status.classList.remove('is-visible'), 5000);
  };
  const save = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); persistent = true; }
    catch { persistent = false; }
  };
  const sync = () => {
    document.querySelectorAll('[data-mm-wish-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', t.open + (items.length ? ': ' + items.length + ' ' + t.count : ''));
      const count = button.querySelector('[data-mm-wish-count]');
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-mm-wish-toggle]').forEach(button => {
      const selected = items.some(item => item.handle === button.dataset.mmWishToggle);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? t.remove : t.add) + ': ' + button.dataset.wishTitle);
      const label = button.querySelector('[data-mm-wish-label]');
      if (label) label.textContent = selected ? t.remove : t.add;
    });
    dialog.querySelector('[data-mm-wish-total]').textContent = items.length ? '(' + items.length + ')' : '';
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const drawCard = (item, current, failed) => {
    const card = element('article', 'mm-wishlist__card');
    card.dataset.wishCard = item.handle;
    const shortTitles = {"mandm-full-mesh-cap-black": "Mesh Cap – Schwarz", "mandm-classic-baseball-cap-racing-red": "Classic Flexfit Cap – Rot", "mandm-classic-baseball-cap-clean-white": "Classic Flexfit Cap – Weiß", "mandm-transparent-visor-trucker-red": "Visor Trucker Cap – Rot", "mandm-heritage-cap-espresso-brown": "Heritage Flexfit Cap – Espresso", "mandm-trucker-cap-red-mesh": "Mesh Trucker Cap – Rot", "mandm-statement-patch-racing-red": "Statement Patch – Rot", "mandm-statement-patch-white-red": "Statement Patch – Weiß/Rot", "mandm-holz-schluessel-anhaenger-natural-brown": "Holz-Schlüsselanhänger – Natur", "mandm-schluessel-anhaenger-gloss-black": "Schlüsselanhänger – Glanzschwarz", "mandm-schluessel-anhaenger-carbon": "Schlüsselanhänger – Carbon", "mandm-acryl-schluessel-anhaenger-clear": "Acryl-Schlüsselanhänger – Transparent", "mandm-acryl-schluessel-anhaenger-burgundy": "Acryl-Schlüsselanhänger – Bordeaux", "mandm-silicon-schluesselanhaenger-white-olive": "Silikon-Schlüsselanhänger – Weiß/Oliv", "mandm-webpatch-sand": "Webpatch – Sand", "mandm-webpatch-olive": "Webpatch – Oliv", "mandm-racing-button-white": "Racing Button – Weiß", "mandm-racing-button-red": "Racing Button – Rot", "mandm-logo-sticker-classic": "Logo-Sticker", "awd-warning-sticker-gelb-schwarz": "AWD-Warnaufkleber – Gelb/Schwarz", "mandm-lanyard-white": "Lanyard – Weiß", "mandm-lanyard-racing-red": "Lanyard – Rot", "mandm-racing-flag-tee-white": "Racing Flag T-Shirt – Weiß", "mandm-retro-badge-tee-white": "Retro Badge T-Shirt – Weiß", "mandm-retro-badge-tee-racing-red": "Retro Badge T-Shirt – Rot", "mandm-racing-flag-tee-racing-red": "Racing Flag T-Shirt – Rot", "mandm-retro-badge-tee-black": "Retro Badge T-Shirt – Schwarz", "mandm-signature-tee-white": "Signature T-Shirt – Weiß", "mandm-ladies-signature-tee-oliv": "Signature Damen-Shirt – Oliv", "mandm-signature-tee-racing-red": "Signature T-Shirt – Rot", "mandm-signature-tee-oliv": "Signature T-Shirt – Oliv", "mandm-ladies-signature-tee-soft-pink": "Signature Damen-Shirt – Rosa", "mandm-signature-tee-espresso-brown": "Signature T-Shirt – Espresso", "madchen-motoren-panty-racing-red": "Panty – Rot", "madchen-motoren-string-racing-red": "String – Rot", "madchen-motoren-string-black-edition": "String – Schwarz", "m-m-underwear-bundle-racing-red": "Underwear-Set – Rot", "m-m-underwear-bundle-red-black": "Underwear-Set – Rot/Schwarz", "maedchen-motoren-retro-track-sweat-jacket-unisex-black-gold": "Retro Trackjacke – Schwarz/Gold", "maedchen-motoren-scheibenkeil-140x20-schwarz-weiss": "Scheibenkeil 140 × 20 cm – Schwarz/Weiß", "madchen-motoren-scheibenkeil-weiss-rot-140-20-cm": "Scheibenkeil 140 × 20 cm – Weiß/Rot", "madchen-motoren-autoaufkleber-19-6-cm-weiss-schwarz-rot-silber": "Autoaufkleber 19 × 6 cm", "madchen-motoren-zip-hoodie-unisex-grey-melange": "Zip-Hoodie – Grau Melange", "damen-zip-sweatjacke-braun": "Zip-Sweatjacke Damen – Braun"};
    const title = (config.locale.startsWith('de') && shortTitles[item.handle]) || (current ? current.title : item.title || item.handle);
    const url = productUrl(item.handle);
    const link = element('a', 'mm-wishlist__image');
    link.href = url;
    link.setAttribute('aria-label', title);
    const src = safeImage(current ? current.featured_image : item.image);
    if (src) {
      const image = element('img', '');
      image.src = src;
      image.alt = (current && current.media && current.media.find(media => media.media_type === 'image')?.alt) || item.alt || title;
      image.width = 600;
      image.height = 600;
      image.loading = 'lazy';
      link.append(image);
    }
    const remove = element('button', 'mm-wishlist__remove', '×');
    remove.type = 'button';
    remove.dataset.mmWishRemove = item.handle;
    remove.setAttribute('aria-label', t.remove + ': ' + title);
    const heading = element('h3', 'mm-wishlist__name');
    const titleLink = element('a', '', title);
    titleLink.href = url;
    heading.append(titleLink);
    card.append(link, remove, heading);
    const price = current ? current.price : item.price;
    if (Number.isFinite(price)) card.append(element('p', 'mm-wishlist__price', money(price)));
    if (current && !current.available) card.append(element('p', 'mm-wishlist__availability', t.unavailable));
    if (failed) card.append(element('p', 'mm-wishlist__error', t.refresh_error));
    const view = element('a', 'mm-wishlist__view', t.view);
    view.href = url;
    card.append(view);
    return card;
  };
  const render = async () => {
    const version = ++generation;
    empty.hidden = items.length > 0;
    grid.replaceChildren(...items.map(item => drawCard(item)));
    sync();
    const queue = items.slice();
    const worker = async () => {
      while (queue.length && version === generation) {
        const item = queue.shift();
        let current, failed = false;
        try {
          const response = await fetch(productUrl(item.handle) + '.js', { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(10000) });
          if (!response.ok) throw new Error('Product unavailable');
          current = await response.json();
        } catch { failed = true; }
        if (version !== generation || !dialog.open) return;
        const card = Array.from(grid.children).find(node => node.dataset.wishCard === item.handle);
        if (card && !card.contains(document.activeElement)) card.replaceWith(drawCard(item, current, failed));
      }
    };
    await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-mm-wish-open]');
    if (opener) {
      openedBy = opener;
      dialog.showModal();
      document.documentElement.classList.add('mm-wishlist-open');
      render();
      if (!persistent) announce(t.storage_error);
      return;
    }
    if (event.target.closest('[data-mm-wish-close]')) { dialog.close(); return; }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      return;
    }
    const button = event.target.closest('[data-mm-wish-toggle], [data-mm-wish-remove]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = button.dataset.mmWishToggle || button.dataset.mmWishRemove;
    if (!valid({ handle })) return;
    const index = items.findIndex(item => item.handle === handle);
    const removed = index >= 0;
    if (removed) items.splice(index, 1);
    else {
      if (items.length >= 100) { announce(t.limit); return; }
      items.unshift({ handle, title: button.dataset.wishTitle, alt: button.dataset.wishAlt, image: safeImage(button.dataset.wishImage), price: Number(button.dataset.wishPrice) });
    }
    save();
    sync();
    announce(persistent ? (removed ? t.removed : t.saved) : t.storage_error);
    if (dialog.open) {
      render();
      const next = grid.querySelector('[data-mm-wish-remove]') || dialog.querySelector('[data-mm-wish-close]');
      next.focus();
    }
  });
  dialog.addEventListener('close', () => {
    generation++;
    document.documentElement.classList.remove('mm-wishlist-open');
    if (openedBy && openedBy.isConnected) openedBy.focus();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    items = parse(event.newValue);
    sync();
    if (dialog.open) render();
  });
  window.addEventListener('pageshow', () => {
    if (dialog.open) dialog.close();
    try { items = parse(localStorage.getItem(key)); } catch { persistent = false; }
    sync();
  });
  document.addEventListener('shopify:section:load', sync);
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-mm-wish-toggle], [data-mm-wish-open]') || node.querySelector('[data-mm-wish-toggle], [data-mm-wish-open]'))))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  sync();
})();

